import {Component, HostListener, OnDestroy, OnInit} from "@angular/core";
import {ErrorHandlerService} from "../../../error-handler.service";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {SignupModel, SignupPages} from "../../signup/signup.model";
import {first, Subscription, timer} from "rxjs";

@Component({
    selector: "fhm-contract-form",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./contract-form.component.html",
    styleUrls: ["./contract-form.component.scss"],
    standalone: false
})
export class ContractFormComponent implements OnInit, OnDestroy {

    url: SafeResourceUrl;

    signing: boolean = true;
    waitingContractStatus: boolean = false;

    waitingContractSubscription: Subscription;

    constructor(private spinnersService: FUISpinnersService,
                private sanitizer: DomSanitizer,
                private errorHandler: ErrorHandlerService,
                public model: SignupModel) {
    }

    ngOnDestroy(): void {
        if (this.waitingContractSubscription) {
            this.waitingContractSubscription.unsubscribe();
        }
    }

    ngOnInit(): void {
        if (this.model.signupStatus.contractUrl) {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.model.signupStatus.contractUrl);
        }
    }

    @HostListener("window:message", ["$event"])
    message(event: MessageEvent) {
        if (event.data === "contract_done") {
            this.signing = false;
            this.waitingContractStatus = true;

            this.startWaitingContractStatus();


            // TODO: update the SignupStatus
            // TODO: show a message that the contract has been signed and will be emailed
            // TODO: show a different message if the director still needs to sign

        }

    }

    startWaitingContractStatus(): void {
        this.waitingContractSubscription = timer(5000).pipe(first()).subscribe(async () => {
            await this.model.refresh(this.model.signupStatus.requiresBilling ? SignupPages.BILLING : SignupPages.COMPLETE);
            if (this.model.signupStatus.requiresContract && !this.model.signupStatus.contractWithdrawn) {
                this.startWaitingContractStatus();
            } else {
                this.waitingContractStatus = false;
            }
        });
    }
}
